import logo from '../../../../assets/Logo_transparent.png';
import footerImage from '../../../../assets/measuring.png';

export const IMAGES = {
  LOGO: logo,
  FOOTER: footerImage
};

export const PAGE_LAYOUT = {
  WIDTH: 210, 
  HEIGHT: 297, 
  CONTENT_WIDTH: 180, 
  MARGIN: 15,
  FOOTER_HEIGHT: 20,
  FOOTER_TOP: 16,
  };
  
  export const COLUMN_WIDTHS = {
    OPTION: 15,
    MEAL_TYPE: (PAGE_LAYOUT.CONTENT_WIDTH - 15) / 5
  };
  
  export const TEXT_STYLES = {
    COLORS: {
      PRIMARY: [44, 62, 80],
      SECONDARY: [100, 100, 100],
      WHITE: [255, 255, 255],
      GRAY: [128, 128, 128],
      TEXT: [52, 73, 94],
      HEADER: [41, 128, 185]
    },
    SIZES: {
      TITLE: 22,
      HEADER: 16,
      SUBHEADER: 14,
      NORMAL: 12,
      SMALL: 10,
      TINY: 8
    }
  };
  
  export const BACKGROUNDS = {
    HEADER: [255, 100, 20],
    ALTERNATE_ROW: [241, 245, 249],
    WATERMARK: [245, 247, 250]
  };
  
  